import {ApiClient} from "./config";

export const getAmbassadorMeReq = async () => {
    return await ApiClient.get(`api/v1/ambassadors/me/`);
}
export const ambassadorRegisterReq = async (data) => {
    return await ApiClient.post(`api/v1/ambassadors/register/`, data);
}

// export const getAmbassadorPayoutsReq = async () => {
//     return await ApiClient.get(`api/v1/ambassadors/payouts/`);
// }
// export const ambassadorRequestPayoutReq = async (data) => {
//     return await ApiClient.post(`api/v1/ambassadors/payouts/request/`, data);
// }
// export const getAmbassadorReferralsReq = async () => {
//     return await ApiClient.get(`api/v1/ambassadors/referrals/`);
// }
export const ambassadorOnboardingLinkReq = async (data) => {
    return await ApiClient.post(`api/v1/ambassadors/onboarding-link/`, data);
}